'use strict';

const Backbone = require('backbone');
const ProjectModel = require('common/domain/entity/project');

class ProjectCollection extends Backbone.Collection {
    constructor(models, options) {
        super(models, options);

        this.model = ProjectModel;
    }

    comparator(project) {
        return project.get('name').toLowerCase();
    }
}

module.exports = ProjectCollection;



// WEBPACK FOOTER //
// ./common/domain/collection/project.js